export default __webpack_public_path__ + "static/media/icon_irpas.6fd04575.webp";